import React from 'react';
export function ReviewsSectionNew() {
  return <section className="reviews-section-new" data-id="element-54">
      <div className="reviews-header-new" data-id="element-55">
        <div className="reviews-rating-new" data-id="element-56">4,8 / 5</div>
        <div className="reviews-stars-new" data-id="element-57">★★★★★</div>
        <div className="reviews-count-new" data-id="element-58">Más de 180 reseñas verificadas</div>
        <div className="reviews-subtitle-new" data-id="element-59">
          Testimonios reales de mujeres en pre y postmenopausia
        </div>
      </div>

      {/* RESEÑA 1 */}
      <div className="review-card-new" data-id="element-60">
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1772539233/15d9e36d-5bb0-4fe3-b30b-8fef237b7c46_xkz8zj.webp" alt="Reseña Florencia G." data-id="element-61" />
        <div className="review-content-new" data-id="element-62">
          <div className="review-top-new" data-id="element-63">
            <div className="review-name-new" data-id="element-64">Florencia G.</div>
            <div className="review-verified-new" data-id="element-65">✔ Verificada</div>
          </div>
          <div className="review-stars-small-new" data-id="element-66">★★★★★</div>
          <div className="review-text-new" data-id="element-67">
            Me encantó lo claro que está todo explicado paso a paso. En una
            semana noté menos hinchazón y mucha más energía.
          </div>
          <div className="review-tags-new" data-id="element-68">
            <span data-id="element-69">Digestión</span>
            <span data-id="element-70">Energía</span>
          </div>
        </div>
      </div>

      {/* RESEÑA 2 */}
      <div className="review-card-new" data-id="element-71">
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1772539233/0de30204-307e-4336-a8eb-373d3ae909b0_r3g7nh.webp" alt="Reseña Cintia A." data-id="element-72" />
        <div className="review-content-new" data-id="element-73">
          <div className="review-top-new" data-id="element-74">
            <div className="review-name-new" data-id="element-75">Cintia A.</div>
            <div className="review-verified-new" data-id="element-76">✔ Verificada</div>
          </div>
          <div className="review-stars-small-new" data-id="element-77">★★★★★</div>
          <div className="review-text-new" data-id="element-78">
            Recetas fáciles y deliciosas. Me siento más saciada y sin esa
            sensación de pesadez después de comer.
          </div>
          <div className="review-tags-new" data-id="element-79">
            <span data-id="element-80">Saciedad</span>
            <span data-id="element-81">Energía estable</span>
          </div>
        </div>
      </div>

      {/* RESEÑA 3 */}
      <div className="review-card-new" data-id="element-82">
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1772539233/db828bbb-d9ee-4019-bf15-36c98e4a561d_jurup8.webp" alt="Reseña Gabriela M." data-id="element-83" />
        <div className="review-content-new" data-id="element-84">
          <div className="review-top-new" data-id="element-85">
            <div className="review-name-new" data-id="element-86">Gabriela M.</div>
            <div className="review-verified-new" data-id="element-87">✔ Verificada</div>
          </div>
          <div className="review-stars-small-new" data-id="element-88">★★★★★</div>
          <div className="review-text-new" data-id="element-89">
            Todo está muy bien organizado. Desde que sigo la guía me noto menos
            inflamada y con más vitalidad durante el día.
          </div>
          <div className="review-tags-new" data-id="element-90">
            <span data-id="element-91">Menos hinchazón</span>
            <span data-id="element-92">Vitalidad</span>
          </div>
        </div>
      </div>

      {/* RESEÑAS SOLO TEXTO */}
      <div className="review-card-new" data-id="element-93">
        <div className="review-content-new" data-id="element-94">
          <div className="review-top-new" data-id="element-95">
            <div className="review-name-new" data-id="element-96">Carla M.</div>
            <div className="review-verified-new" data-id="element-97">✔ Verificada</div>
          </div>
          <div className="review-stars-small-new" data-id="element-98">★★★★★</div>
          <div className="review-text-new" data-id="element-99">
            No imaginaba que pequeños cambios marcaran tanta diferencia. He
            notado mejoras en el descanso y en mi energía diaria.
          </div>
        </div>
      </div>

      <div className="review-card-new" data-id="element-100">
        <div className="review-content-new" data-id="element-101">
          <div className="review-top-new" data-id="element-102">
            <div className="review-name-new" data-id="element-103">Rocío C.</div>
            <div className="review-verified-new" data-id="element-104">✔ Verificada</div>
          </div>
          <div className="review-stars-small-new" data-id="element-105">★★★★★</div>
          <div className="review-text-new" data-id="element-106">
            Muy práctico y fácil de seguir. Me ha ayudado a sentirme más ligera
            y con menos inflamación.
          </div>
        </div>
      </div>

      <div className="review-card-new" data-id="element-107">
        <div className="review-content-new" data-id="element-108">
          <div className="review-top-new" data-id="element-109">
            <div className="review-name-new" data-id="element-110">Lorena P.</div>
            <div className="review-verified-new" data-id="element-111">✔ Verificada</div>
          </div>
          <div className="review-stars-small-new" data-id="element-112">★★★★★</div>
          <div className="review-text-new" data-id="element-113">
            En pocas semanas he notado más estabilidad y mejor digestión. Muy
            recomendable.
          </div>
        </div>
      </div>
    </section>;
}